<template>
	<div class="shop-dark-wrapper px-4 px-sm-6 px-md-10 text-center">
		<!-- Header Logo -->
		<v-col cols="12" class="d-flex justify-center pt-8 mb-4">
			<v-img height="50px" max-width="150px" @click="$router.push('/')" contain src="/img/roodyLogoGreen.png" style="cursor: pointer;"></v-img>
		</v-col>

		<!-- Celebratory Checkmark -->
		<div class="success-checkmark my-6 animate-fade-in-up stagger-1">
			<div class="check-icon">
				<span class="icon-line line-tip"></span>
				<span class="icon-line line-long"></span>
				<div class="icon-circle"></div>
			</div>
		</div>

		<!-- Title Section -->
		<div class="animate-fade-in-up stagger-2 mb-8">
			<h1 class="premium-title-gradient text-h4 font-weight-black mb-2">Vielen Dank für deinen Einkauf!</h1>
			<p class="grey--text text--lighten-1 mx-auto" style="max-width: 600px; font-size: 1.05rem; line-height: 1.5;">
				Du kannst deine gekauften Produkte / Gutscheine nun direkt herunterladen. Deine Einkäufe findest du im Anschluss auch immer in deinem Profil unter "Einkäufe".
			</p>
		</div>

		<!-- Product Voucher Grid -->
		<v-row class="justify-center animate-fade-in-up stagger-3 px-2">
			<v-col 
				cols="12" 
				sm="6" 
				md="4" 
				v-for="(product, index) of data[0].products" 
				:key="'produkt-' + index"
				class="d-flex"
			>
				<v-card 
					dark 
					flat 
					class="glass-card fill-height d-flex flex-column" 
					style="overflow: hidden; width: 100%; border: 1px dashed rgba(255, 255, 255, 0.15) !important;"
				>
					<div class="image-zoom-container pa-3">
						<v-img aspect-ratio="1.6" class="rounded-xl" :src="'/img/' + product.picture"></v-img>
					</div>

					<v-card-title class="justify-center white--text font-weight-bold pt-3 pb-1 text-h6">
						{{ product.title }}
					</v-card-title>
					
					<v-card-text class="flex-grow-1 px-4 py-2">
						<div class="text-subtitle-1 white--text font-weight-bold mb-2">
							für {{ product.personalization.prename }} {{ product.personalization.lastname }}
						</div>
						
						<!-- Styled quote box for voucher text -->
						<div class="pa-3 rounded-lg text-left mb-3" style="background: rgba(255,255,255,0.02); border-left: 3px solid #00B074; font-size: 0.9rem; line-height: 1.4; min-height: 60px;">
							<span class="grey--text text--lighten-2">"{{ product.personalization.text }}"</span>
						</div>
					</v-card-text>

					<v-divider class="mx-4" style="background-color: rgba(255,255,255,0.08);"></v-divider>

					<v-card-text class="py-4 d-flex justify-space-between align-center px-6">
						<span class="grey--text text-caption">Gutscheinwert</span>
						<span style="color: #00B074; font-weight: 800; font-size: 1.25rem;">CHF {{ product.price }}.-</span>
					</v-card-text>

					<!-- Download button inside ticket -->
					<div class="pa-4 pt-0">
						<v-btn 
							@click="downloadFile(index)" 
							class="premium-btn py-5" 
							block
						>
							<v-icon left>mdi-download</v-icon>
							Ausdruck herunterladen
						</v-btn>
					</div>
				</v-card>
			</v-col>
		</v-row>

		<!-- Bottom navigation button -->
		<v-col cols="12" class="text-center mt-12 mb-10 animate-fade-in-up stagger-4">
			<v-btn 
				class="premium-btn-outline px-10 py-6"
				x-large 
				@click="$router.push('/user')"
			>
				<v-icon left>mdi-account-circle-outline</v-icon>
				Zum Profil wechseln
			</v-btn>
		</v-col>
	</div>
</template>

<script>
	import api from '../../api'
	import { mapGetters, mapActions, mapState } from 'vuex'

	export default {
		data() {
			return {
				data: { products: [] },
			}
		},
		async created() {
			if (this.$route && this.$route.params && this.$route.params.id) {
				this.data = await api.getPaymentInfos(this.$route.params.id)
				console.log(this.data, 'da isch de purchase')
			} else {
				this.$toast.error('Dein Einkauf wurde nicht gefunden oder konnte nicht deinem Account zugewiesen werden')
				this.$router.push('/')
			}
		},
		methods: {
			async downloadFile(index) {
				this.$toast.success('Dein Ausdruck wird generiert')
				await api.downloadRealVoucher({ _id: this.data[0]._id, product: index })
			},
		},
	}
</script>

<style>
@import './shopCommon.css';
</style>

